import { BehaviorSubject } from 'rxjs';
import { ContextData } from 'src/app/data/context.data';
import { EventEmitter } from '@angular/core';
import { LabelEvent } from 'src/app/events/label.event';

export class LayerData {

  public onChange: EventEmitter<LabelEvent> = new EventEmitter<LabelEvent>();

  // CONST
  static TEXT:string = "TextLayer";
  static SQUARE_SHAPE:string = "SquareShapeLayer";
  static TRIANGLE_SHAPE:string = "TriangleShapeLayer";
  static CIRCLE_SHAPE:string = "CircleShapeLayer";
  static WINGDINGS_SHAPE:string = "WingdingsShapeLayer";
  static LINE_SHAPE:string = "LineShapeLayer";
  static SHAPE:string = "ShapeLayer";
  static SVG_SHAPE:string = "SVGShapeLayer";
  static IMAGE:string = "ImageLayer";

  static DESIGN:string = "DesignLayer";
  static CREATION:string = "CreationLayer";
  static EXCEL:string = "ExcelLayer";
  static CLIPBOARD:string = "ClipBoardLayer";
  static DUPLICATION:string = "DuplicationLayer";

  protected _tintable: boolean = false;

  protected _source:string = LayerData.CREATION;

  protected _type:string;
  protected _special:string;
  protected _index:number = -1;
  protected _rotation:number;
  protected _alpha:number;
  protected _x:number; // en mm, getter en px
  protected _y:number; // en mm, getter en px
  protected _width:number; // en mm, getter en px
  protected _height:number; // en mm, getter en px
  protected _locks:any;

  private _centerRotation:number;
  private _uid:number;

  /**
   * Contructor
   */
  constructor(x:number = 0, y:number = 0, width:number = NaN, height:number = NaN, rotation:number = 0, alpha:number = 1, locks:any = null, source:string = "CreationLayer", special:string = null) {
    this._x = x;
    this._y = y;
    this._width = width;
    this._height = height;
    this._rotation = rotation;
    this._alpha = alpha;
    this._source = source;
    this._special = special;

    this.locks = locks;

    this._uid = ContextData.UID++;

  }

  public get centerRotation():number {
    return this._centerRotation;
  }

  public set centerRotation(value:number) {
    this._centerRotation = value;
  }

  /**
   * Cleanup
   */
  public cleanup():void {

  }

  /**
   * Type
   */
  public get type():string {
    return this._type;
  }
  public set type(value:string) {
    this._type = value;
  }

  /**
   * Index
   */
  public get index():number {
    return this._index;
  }
  public set index(value:number) {
    this._index = value;
  }

  /**
   * Index
   */
  public get source():string {
    return this._source;
  }

  public set source(value:string) {
    this._source = value;
  }

  /**
   * Locks
   */
  public get locks():any {
    return this._locks;
  }

  public set locks(value:any) {
    if (value == null) {
      this._locks = {position:false, rotation:false, size:false, deletion:false, depth:false, crop:false, tint:false};
    } else {
      this._locks = value;
    }
  }

  /**
   * x
   */
  public get x():number {
    return this._x * ContextData.MM_TO_PIXELS;
  }

  public set x(value:number) {
    this._x = value / ContextData.MM_TO_PIXELS;
  }

  /**
   * y
   */
  public get y():number {
    return this._y * ContextData.MM_TO_PIXELS;
  }

  public set y(value:number) {
    this._y = value / ContextData.MM_TO_PIXELS;
  }

  /**
   * rotation
   */
  public get rotation():number {
    return this._rotation;
  }

  public set rotation(value:number) {
    this._rotation = value;
  }

  /**
   * alpha
   */
  public get alpha():number {
    return this._alpha;
  }

  public set alpha(value:number) {
    this._alpha = value;
  }

  /**
   * Clone
   */
  public clone(keepLocks:boolean = false):LayerData {
    return null;
  }

  /**
   * Width
   */
  public get width():number {
    return this._width * ContextData.MM_TO_PIXELS;
  }

  public set width(value:number) {
    this._width = value / ContextData.MM_TO_PIXELS;
  }

  /**
   * Height
   */
  public get height():number {
    return this._height * ContextData.MM_TO_PIXELS;
  }

  public set height(value:number) {
    this._height = value / ContextData.MM_TO_PIXELS;
  }

  /**
   * Special
   */
  public get special():string {
    return this._special;
  }

  public set special(value:string) {
    this._special = value;
  }

  /**
   * tintable
   */
  public get tintable(): boolean {
    return this._tintable;
  }


  public get uid():number {
    return this._uid;
  }

  /**
  * Invalidate
  */
  public invalidate() {
    this.onChange.emit(new LabelEvent(LabelEvent.UPDATE_LAYER, this));
  }

  /**
	 * Get data
	 */
  public getData(): any {
    var returnData:any = {};

    return returnData;
  }


}

export enum LAYER_TYPE {
	TEXT = 1,
  PICTURE = 2,
  SVG = 3,
  LOGO = 4,
  BACKGROUND = 5,
  SHAPE = 3
}
